import React from 'react'
import EssLayout from '../../../../layout/components/ESSLayout'
import { useEssAppData } from '../../../../context/AppESSDataContext'
import DPRForm from '../components/DPRForm';
import { useAppData } from '../../../../context/AppDataContext';
import moment from 'moment';

function ESSAssignedProjectListPage() {
    
    const {projectList,getProjectList} = useEssAppData();
    const {getMasterLabel} = useAppData();
    
    
  return (
    <EssLayout>
            <div className='row'>
                <div className='col-md-12'>
                    
                </div>
            </div>
            <div className='row'>
                {projectList && projectList.length == 0 &&
                    <div className='col-md-12'>
                        <div className="alert alert-info" role="alert">
                            <h4 className="alert-heading">Nothing Here !</h4>
                            <p>No Project Assigned to you</p>
                            <hr/>
                            <p className="mb-0">Please contact Admin / Manager  </p>
                        </div>
                    </div>
                }
                {projectList && projectList.map(project=>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header'>
                                {project.title}
                            </div>
                            <div className='card-body'>
                                <table className='table table-bordered'>
                                    <tbody>
                                        {project.targetList.map(target=>
                                            <tr key={target.id}>
                                                <th>{target.title}</th>
                                                <td>{target.completed} / {target.total}</td>
                                                <td>{getMasterLabel('product-uom',target.uom)}</td>
                                                <td>{moment(target.dueDate).format("LL")}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className='card-footer'>
                                <DPRForm projectId={project.id} targetList={project.targetList} callBack={getProjectList} />
                            </div>
                        </div>
                    </div>
                )}
            </div>

    </EssLayout>
  )
}

export default ESSAssignedProjectListPage